import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import "react-quill/dist/quill.snow.css";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import sweetalert2 from "sweetalert2";
import { useNavigate } from "react-router-dom";
import JoditEditor from 'jodit-react';
import { getTags, updateCommonTemplet } from "../../../ReduxStore/Slice/Templets/QuotesTemplets";
import { EMPTY_TEMPLET_NAME_ERROR, EMPTY_TEMPLET_BODY_ERROR } from "../../../Utils/Common_Error";
import { useLocation } from "react-router-dom";
import axios from 'axios';
import * as Config from "../../../Utils/Config";

const EditCommonTemplet = () => {
  const editor = useRef(null);
  const location = useLocation();
  const [editorReady, setEditorReady] = useState(false);
  const [content, setContent] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const [error, setError] = useState({});
  const [getTagsData, setTagsData] = useState({
    client: [],
    practice: [],
    user_profile: [],
    other: []
  });

  const [formData, setFormData] = useState({
    templateName: "",
    body: "",
  });

  useEffect(() => {
    if (location.state) {
      setFormData({
        templateName: location.state.name,
        body: location.state.body,
      });
    }
  }, [location.state]);



  useEffect(() => {
    Tags();
  }, []);

// 🔹 MS Word / PDF formatting cleaner
const cleanWordHtml = (html = "") => {
  if (!html) return html;

  html = html.replace(/<style[\s\S]*?<\/style>/gi, "");
  html = html.replace(/<!--[\s\S]*?-->/g, "");
  html = html.replace(/mso-[a-z\-]+\s*:[^;"]+(;|")/gi, "");  
  html = html.replace(/<o:p>\s*<\/o:p>|<o:p>.*?<\/o:p>/gi, "");

  return html;
};


const UpdateFormBody = useCallback((value) => {
  if (editor.current && editor.current.selection) {
    const imgTag = `<img src="${value}" 
                     width="252" height="160"
                     style="display:inline-block;margin:5px;vertical-align:middle;">`;

    editor.current.selection.insertHTML(imgTag);  // 👈 NOW AT CURSOR
  }
}, []);



const config1 = useMemo(() => ({

   readonly: false,
      placeholder: "",
      buttons:
        "bold,italic,underline,strikethrough,ul,ol,paragraph,fontsize,font,brush,link,image,video,table,align,undo,redo,cut,copy,paste,selectall,source",
      removeButtons: ["speechRecognize"],
      toolbarSticky: false,
  
      style: {
        font: '14px "Times New Roman", Arial, sans-serif',
        color: "#000000",
        lineHeight: "1.4",
      },
  
      controls: {
        font: {
          list: {
            Poppins: '"Poppins", sans-serif',
            Arial: "Arial, Helvetica, sans-serif",
            "Times New Roman": '"Times New Roman", Times, serif',
            Roboto: "Roboto, sans-serif",
            Verdana: "Verdana, Geneva, sans-serif",
          },
        },
      },
  
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      defaultActionOnPaste: "insert_clear_html",  
      defaultActionOnPasteFromWord: "insert_clear_html",  
      
      processPasteHTML: (html) => {
        return cleanWordHtml(html);  
      },
      
      processPasteFromWord: (html) => {
        return cleanWordHtml(html);  
      },
  
      uploader: {
        url: Config.base_url + "img/uploader",
        accept: "image/*,video/*",
        method: "POST",
        withCredentials: false,
        prepareData: async (formData1) => {
          const data = new FormData();
          formData1.forEach((file) => {
            data.append("files[0]", file);
          });

      try {
        const response = await axios.post(
          Config.base_url + "img/uploader",
          data,{ headers:{ "Content-Type":"multipart/form-data" }}
        );

        if (response?.data?.files?.[0]) {
          UpdateFormBody(response.data.files[0]);  

          return { success:true, files:response.data.files };
        }
        return { success:false, files:[] };

      } catch {
        return { success:false, files:[] };
      }
    },

    defaultHandlerSuccess: (res) => res?.files ?? [],
    defaultHandlerError: () => []
  },


  events: {
    afterInit: (editorInstance) => {
      setEditorReady(true);
      editor.current = editorInstance;
    }
  },

  style:{
    "ol":{ "list-style-type":"decimal" },
    "ol ol":{ "list-style-type":"decimal" }
  }

}), [UpdateFormBody]);




  const Tags = async () => {
    const req = { agent_id: agent_id };
    await dispatch(getTags(req))
      .unwrap()
      .then((res) => {
        if (res.status) {


          const filterClient = res.data.filter((data) => data.type == "client");
          const filterPractice = res.data.filter(
            (data) => data.type == "practice"
          );
          const filterUserProfile = res.data.filter(
            (data) => data.type == "user_profile"
          );

          const filterOther = res.data.filter(
            (data) => data.type == "other" && data.name != "services"
          )
          setTagsData({
            client: filterClient,
            practice: filterPractice,
            user_profile: filterUserProfile,
            other: filterOther
          });
        } else {
          setTagsData({ client: [], practice: [], user_profile: [], other: [] });
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };

  const handleAddTemplate = async () => {
    if (!validateAllFields()) {
      return;
    }

    sweetalert2.fire({
      title: "Are you sure?",
      text: "You want to update this common template?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
      cancelButtonText: "No, cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const user_id = JSON.parse(localStorage.getItem("details")).id;
        const req = { id: location.state.id, name: formData.templateName, body: formData.body, agent_id: agent_id, user_id: user_id }

        await dispatch(updateCommonTemplet(req)).unwrap()
          .then((res) => {
            if (res.status) {
              sweetalert2.fire({
                title: 'Success',
                text: res.message,
                icon: 'success',
                confirmButtonText: 'OK',
                timer: 3000,
                timerProgressBar: true
              }).then(() => {
                navigate('/admin/template/all-common-template')
              })
            }
            else {
              sweetalert2.fire({
                title: 'Error',
                text: res.message,
                icon: 'error',
                confirmButtonText: 'OK',
                timer: 3000,
                timerProgressBar: true
              })
            }
          })
          .catch((err) => {
            console.log("Error", err)
          })
      }
    });
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    validate(name, value);
  };



  const deleteErrorMsg = (name) => {
    setError((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[name];
      return updatedErrors;
    });
  };

  const validate = (name, value) => {
    const newErrors = { ...error };
    if (!value) {
      switch (name) {
        case "templateName":
          newErrors.templateName = EMPTY_TEMPLET_NAME_ERROR;
          break;
        case "body":
          newErrors.body = EMPTY_TEMPLET_BODY_ERROR;
        default:
          break;
      }
    } else {
      delete newErrors[name];
      deleteErrorMsg(name);
    }

    if (Object.keys(newErrors).length !== 0) {
      setError((prevErrors) => ({
        ...prevErrors,
        ...newErrors,
      }));
    }

    return Object.keys(newErrors).length === 0;
  };


  const validateAllFields = () => {
    let isValid = true;
    for (const key in formData) {
      if (!validate(key, formData[key])) {
        isValid = false;
      }
    }
    return isValid;
  };

  const insertTag = (tag) => {
    if (editorReady && editor.current) {
      const editorInstance = editor.current;
      if (editorInstance && editorInstance.selection) {
        editorInstance.selection.insertHTML(`{{${tag?.name?.toUpperCase()}}}\t\t`);
      }
    }
  };


  return (
    <div>
      <div className="row mb-3">
        <div className="col">
          <h4 className="page-title">
            <Link to="/admin/template/all-common-template">
              <i className="bx bx-arrow-back text-pink pe-1"></i>
            </Link>
            Update Template
          </h4>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-md-8">
          <div className="card">
            <div className="card-body tempaltes">
              <div className=" needs-validation">
                <div className="row mb-4">
                  <div className="col-md-12 mb-3">
                    <div className="row">
                      <label
                        htmlFor="inputEmail3"
                        className="col-sm-3 col-form-label"
                      >
                        Template name:
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          name="templateName"
                          onChange={handleInputChange}
                          value={formData.templateName}
                          disabled={["PARTIAL_LOGO", "PARTIAL_CONTRACT_HEADER", "PARTIAL_CONTRACT_FOOTER"].includes(formData.templateName) ? true : false}
                        />
                        {error.templateName && (
                          <div className="error-text">
                            {error.templateName}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="row">
                      <label className="col-sm-12 col-form-label">Body:</label>
                      <div className="col-sm-12">
                        <JoditEditor
                          ref={editor}
                          config={config1}
                          tabIndex={1}
                          onBlur={(newContent) => setContent(newContent)}
                          name="body"
                          onChange={(value) => {
                            setFormData({ ...formData, body: value });
                            validate("body", value);
                          }}
                          value={formData.body || ""}
                        />
                        {error.body && (
                          <div className="error-text">{error.body}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" col-auto text-end">
                  <button
                    className="btn btn-outline-secondary rounded"
                    onClick={() =>
                      navigate("/admin/template/all-common-template")
                    }
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-pink rounded ms-2"
                    onClick={handleAddTemplate}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="quill-editor-full"></div>
        </div>
        <div className="col-md-4">
          <div className="card pt-3 px-2 sticky-card">
            <h5 className="text-gray">
              Tag Provision <i class="bx bx-info-circle text-pink"></i>
            </h5>
            <ul
              class="nav nav-tabs nav-tabs-bordered d-flex"
              id="borderedTabJustified"
              role="tablist"
            >
              <li class="nav-item flex-fill" role="presentation">
                <button
                  class="nav-link w-100 active"
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#bordered-justified-home"
                  type="button"
                  role="tab"
                  aria-controls="Client"
                  aria-selected="true"
                >
                  Client
                </button>
              </li>
              <li class="nav-item flex-fill" role="presentation">
                <button
                  class="nav-link w-100"
                  id="profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#bordered-justified-profile"
                  type="button"
                  role="tab"
                  aria-controls="Practice"
                  aria-selected="false"
                >
                  Practice
                </button>
              </li>
              <li class="nav-item flex-fill" role="presentation">
                <button
                  class="nav-link w-100"
                  id="contact-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#bordered-justified-contact"
                  type="button"
                  role="tab"
                  aria-controls="User-Profile"
                  aria-selected="false"
                >
                  User Profile
                </button>
              </li>

              <li class="nav-item flex-fill" role="presentation">
                <button
                  class="nav-link w-100"
                  id="contact-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#bordered-justified-Others"
                  type="button"
                  role="tab"
                  aria-controls="Other"
                  aria-selected="false"
                >
                  Other
                </button>
              </li>
            </ul>
            <div class="tab-content p-3" id="borderedTabJustifiedContent">
              <div
                class="tab-pane fade show active"
                id="bordered-justified-home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                {/* Tag buttons */}
                <div className="tag-buttons">
                  {getTagsData.client.map((tag) => (
                    <button key={tag.id} onClick={() => insertTag(tag)} className="tag-btn">
                      {"+ " + (tag?.name === "clientCompanyDirectorAddress" ? "DirectorAddress".toUpperCase() :
                        tag?.name?.toUpperCase())}
                    </button>
                  ))}
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="bordered-justified-profile"
                role="tabpanel"
                aria-labelledby="profile-tab"
              >

                <div className="tag-buttons">
                  {getTagsData.practice.map((tag) => (
                    <button key={tag.id} onClick={() => insertTag(tag)} className="tag-btn">
                      {"+ " + (tag?.name === "company_name" ? "AccountantCompanyName".toUpperCase() :
                        tag?.name === "incorporated_in" ? "AccountantCompanyIncorporatedIn".toUpperCase() :
                          tag?.name === "company_no" ? "AccountantCompanyRegNumber".toUpperCase() :
                            tag?.name === "agent_registered_address" ? "AccountantCompanyRegAddress".toUpperCase() :
                              tag?.name === "name_of_the_affiliated_accouting_body" ? "NameOfTheAffiliatedAccountingBody".toUpperCase() :

                                tag?.name?.toUpperCase())}
                    </button>
                  ))}
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="bordered-justified-contact"
                role="tabpanel"
                aria-labelledby="contact-tab"
              >
                {getTagsData.user_profile.map((tag) => (
                  <button
                    key={tag.id}
                    onClick={() => insertTag(tag)}
                    className="tag-btn"
                  >
                    {"+ " + tag?.name?.toUpperCase()}
                  </button>
                ))}
              </div>


              <div
                class="tab-pane fade"
                id="bordered-justified-Others"
                role="tabpanel"
                aria-labelledby="contact-tab"
              >
                {getTagsData.other.map((tag) => (
                  <button
                    key={tag.id}
                    onClick={() => insertTag(tag)}
                    className="tag-btn"
                  >
                    {"+ " + tag?.name?.toUpperCase()}
                  </button>
                ))}


              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCommonTemplet;
